<main>
    <div class="content">
        <div class="image-container">
            <img [src]="baseApiUrl + '/uploads/images/company_milestone/company_milestone_1.jpg'" alt="" class="main-image">
            <p class="image-text">{{ "milestone.Company's Milestone" | translate }}</p>
        </div>
        <div class="paragraph">
            <div class="row">
                <div class="col-lg-8 col-md-8 col-sm-8 col-12">
                    <div class="card">
                        <h6>
                            <span class="highlight-text" style="background-color: #B88400;">2022</span>
                        </h6>
                        <p>{{ 'milestone.Moving to the head office at Khan Boeng Keng Kang.' | translate }} 
                            <br>{{ 'milestoneOpened Odongk district and Boeng Keng Kang branches.' | translate }}</p>
                    </div>
                    <div class="card">
                        <h6>
                            <span class="highlight-text" style="background-color: #B4B800;">2021</span>
                        </h6>
                        <p>{{ 'milestone.Opened Bati district and Krong Bavet branches.' | translate }}</p>
                    </div>
                    <div class="card">
                        <h6>
                            <span class="highlight-text" style="background-color: #1AB800;">2020</span>
                        </h6>
                        <p>{{ 'milestone.Increased share capital to USD 25 million.' | translate }}
                            <br>{{ 'milestone.Opened Kampong Cham and Chbar Ampov branches.' | translate }}</p>
                    </div>
                    <div class="card">
                        <h6>
                            <span class="highlight-text" style="background-color: #93B800;">2019</span>
                        </h6>
                        <p>{{ 'milestone.Opened Prey Veng and Svay Rieng provincial branches.' | translate }}</p>
                    </div>
                    <div class="card">
                        <h6>
                            <span class="highlight-text" style="background-color: #006BB8;">2018</span>
                        </h6>
                        <p>{{ 'milestone.NongHyup Bank acquired 100% share in SAMIC Plc.' | translate }}
                            <br>{{ 'milestone.SAMIC Plc changed to NongHyup Finance (Cambodia) Plc.' | translate }}</p>
                    </div>
                    <div class="card">
                        <h6>
                            <span class="highlight-text" style="background-color: #008CB8;">2017</span>
                        </h6>
                        <p>{{ 'milestone.Increase share capital to USD 5 million.' | translate }}</p>
                    </div>
                    <div class="card">
                        <h6>
                            <span class="highlight-text" style="background-color: #B86E00;">2016</span>
                        </h6>
                        <p>{{ 'milestone.Opened Kralanh district branch.' | translate }}</p>
                    </div>
                    <div class="card">
                        <h6>
                            <span class="highlight-text" style="background-color: #C7BF00;">2015</span>
                        </h6>
                        <p>{{ 'milestone.Opened Baray district branch.' | translate }}</p>
                    </div>
                    <div class="card">
                        <h6>
                            <span class="highlight-text" style="background-color: #004FC7;">2014</span>
                        </h6>
                        <p>{{ 'milestone.Opened Kampong Thom provincial branch.' | translate }}</p>
                    </div>
                    <div class="card">
                        <h6>
                            <span class="highlight-text" style="background-color: #63C700;">2012</span>
                        </h6>
                        <p>{{ 'milestone.Increase share capital to USD 3 million.' | translate }}
                            <br>{{ 'milestone.SAMIC Limited changed to SAMIC Plc.' | translate }}
                            <br>{{ 'milestone.Opened Chhuk, Stueng Hav, Puok district and Takeo provincial branches.' | translate }}</p>
                    </div>
                    <div class="card">
                        <h6>
                            <span class="highlight-text" style="background-color: #B88400;">2011</span>
                        </h6>
                        <p>{{ 'milestone.Opened Banteay Meas district branch' | translate }}</p>
                    </div>
                    <div class="card">
                        <h6>
                            <span class="highlight-text" style="background-color: #B4B800;">2010</span>
                        </h6>
                        <p>{{ 'milestone.Opened Khan Saen Sokh branch' | translate }}</p>
                    </div>
                    <div class="card">
                        <h6>
                            <span class="highlight-text" style="background-color: #1AB800;">2009</span>
                        </h6>
                        <p>{{ 'milestone.CHC Limited change to SAMIC Limited' | translate }}
                        <br>{{ 'milestone.Increased share capital to USD 1.3 million' | translate }}
                        <br>{{ 'milestone.Opened Mean Chey branch, Angkor Chey, and S’ang district branches' | translate }}</p>
                    </div>
                    <div class="card">
                        <h6>
                            <span class="highlight-text" style="background-color: #93B800;">2008</span>
                        </h6>
                        <p>{{ 'milestone.Permanent microfinance license from NBC' | translate }}
                        <br>{{ 'milestone.Opened Siem Reap and Kep provincial branches' | translate }}</p>
                    </div>
                    <div class="card">
                        <h6>
                            <span class="highlight-text" style="background-color: #006BB8;">2007</span>
                        </h6>
                        <p>{{ 'milestone.Increased share capital to USD 600,000' | translate }}
                        <br>{{ 'milestone.Opened Kandal provincial branch' | translate }}</p>
                    </div>
                    <div class="card">
                        <h6>
                            <span class="highlight-text" style="background-color: #008CB8;">2006</span>
                        </h6>
                        <p>{{ 'milestone.Opened Prey Nob district branch' | translate }}</p>
                    </div>
                    <div class="card">
                        <h6>
                            <span class="highlight-text" style="background-color: #B86E00;">2005</span>
                        </h6>
                        <p>{{ 'milestone.CHC Limited established & obtained a microfinance license from NBC' | translate }}</p>
                    </div>
                    <div class="card">
                        <h6>
                            <span class="highlight-text" style="background-color: #C7BF00;">2000</span>
                        </h6>
                        <p>{{ 'milestone.CHC expanded its operations to Kampong Trach district, Kampot province' | translate }}</p>
                    </div>
                    <div class="card">
                        <h6>
                            <span class="highlight-text" style="background-color: #004FC7;">1994</span>
                        </h6>
                        <p>{{ 'milestone.CHC established' | translate }}</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                    <app-side-menu></app-side-menu>
                </div>
            </div>
        </div>
        <div class="bottom-content-poster">
            <img [src]="baseApiUrl + '/uploads/images/customer_service/customer_service_1.jpg'" alt="">
            <a href="/download-app"><img [src]="baseApiUrl + '/uploads/images/mobile_download/mobile_download_1.jpg'" loading="lazy"></a>
        </div>
    </div>
</main>